var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(0.419 0.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    transform: "translate(-0.419 -0.509)",
    fill: "rgba(255,0,0,0.5)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24857",
    "data-name": "Path 24857",
    d: "M9.126,4.85V2H23.378V4.85H30.5V7.7h-2.85V29.079A1.425,1.425,0,0,1,26.229,30.5H6.276A1.425,1.425,0,0,1,4.85,29.079V7.7H2V4.85ZM7.7,7.7V27.654H24.8V7.7Zm4.276,4.276h2.85v11.4h-2.85Zm5.7,0h2.85v11.4h-2.85Z",
    transform: "translate(18.541 18.451)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.96bfe2f2f40b7d173cd937f2fa88954a.svg";
export { ForwardRef as ReactComponent };